import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import logger from "lib/logger";
import "./index.scss";
import AccountInfo from "../../components/AccountInfo";
import { selectAccount } from "lib/redux/selectors";
import t, { getLocale } from "locales";
import ArrowRight from "../../assets/right.svg";
import { OtherOptions } from "../../components/OtherOptions";

interface Props {
  account: {
    address: string;
    accountInfo: any;
    resource: any;
  };
}

class Page extends Component<Props, any> {
  componentDidMount() {
    logger().track("to_home");
  }

  render() {
    const locale = getLocale();
    const helpUrl = `https://support.token.im/hc/${
      locale === "zh" ? "zh-cn" : "en-us"
    }/articles/360037636294`;
    return (
      <div className="home" id="home">
        <AccountInfo account={this.props.account} showResourceManagement={true} stakingVersion={2} />
        <div className="helplink">
          <a href="/tron/v1unstake">
            {t('unfreeze_v1_staked_trx')} <img src={ArrowRight} alt="power" />
          </a>
        </div>
        <OtherOptions />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    account: selectAccount(state),
  };
};

const mapDispatchToProps = {};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Page));
